module.exports = __webpack_public_path__ + "img/share-bg.ff02aa33.png";